import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';
import {
  GameDetailsTopMessages,
  GameDetailsTopPropTypes,
} from '../GameDetailsTop';
import GameLaunchLink from './GameLaunchLink';
import GamePracticeLink from './GamePracticeLink';

interface GameDetailsTopInfoPropTypes {
  game: GameTileProps;
  staticTexts: GameDetailsTopMessages;
  pageTitle?: string;
  onGameButtonClick: GameDetailsTopPropTypes['onGameButtonClick'];
}

const GameDetailsTopInfo: React.FC<GameDetailsTopInfoPropTypes> = React.memo(
  ({ game, staticTexts, pageTitle, onGameButtonClick }) => {
    return (
      <div className={cx(styles.linkWrapper)}>
        <GameLaunchLink
          game={game}
          playButtonText={staticTexts.playButton}
          pageTitle={pageTitle}
          onGameClick={onGameButtonClick}
        />
        <GamePracticeLink
          game={game}
          practiveButtonText={staticTexts.practiceButton}
          pageTitle={pageTitle}
          onGameClick={onGameButtonClick}
        />
      </div>
    );
  },
  (
    prevProps: GameDetailsTopInfoPropTypes,
    nextProps: GameDetailsTopInfoPropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GameDetailsTopInfo;
